module.exports = __webpack_public_path__ + "img/bravo.736bff08.png";